"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRemainingAccountsForExecuteSaleIx = exports.getNftCreators = exports.treasuryMintIsNative = exports.sendTx = exports.compileAtaCreationIxs = exports.getBidData = exports.getAuctionData = exports.getEditionVaultData = exports.getCandyShopData = exports.getSignedTx = exports.getEditionMarkAccount = exports.getMasterEditionAccount = exports.getMetadataAccount = exports.getAtaForMint = exports.getEditionVaultAccount = exports.getAuctionHouseEscrow = exports.getAuctionHouseTreasuryAcct = exports.getAuctionHouseFeeAcct = exports.getAuctionHouseTradeState = exports.getAuctionHouseProgramAsSigner = exports.getCandyShopSync = exports.getCandyShop = exports.getAuctionHouseAuthority = exports.getAuctionHouse = exports.getBidWallet = exports.getBid = exports.getAuction = exports.getProgram = exports.getCandyShopVersion = exports.getNodeWallet = void 0;
const anchor_1 = require("@project-serum/anchor");
const pubkey_1 = require("@project-serum/anchor/dist/cjs/utils/pubkey");
const spl_token_1 = require("@solana/spl-token");
const constants_1 = require("../../factory/constants");
const BaseShopModel_1 = require("../../shop/base/BaseShopModel");
const candy_shop_json_1 = __importDefault(require("../../idl/candy_shop.json"));
const candy_shop_v2_json_1 = __importDefault(require("../../idl/candy_shop_v2.json"));
const error_1 = require("../error");
const parseData_1 = require("../token/parseData");
const promiseUtils_1 = require("./promiseUtils");
const transactionUtils_1 = require("./transactionUtils");
/**
 * Get NodeWallet from specified keypair
 *
 * @param {Keypair} wallet keypair wallet will be created for
 * @returns
 */
const getNodeWallet = (wallet) => {
    const NodeWallet = require('@project-serum/anchor/dist/cjs/nodewallet').default;
    return new NodeWallet(wallet);
};
exports.getNodeWallet = getNodeWallet;
const getCandyShopVersion = (shopProgramId) => {
    return shopProgramId.equals(constants_1.CANDY_SHOP_V2_PROGRAM_ID) ? BaseShopModel_1.CandyShopVersion.V2 : BaseShopModel_1.CandyShopVersion.V1;
};
exports.getCandyShopVersion = getCandyShopVersion;
/**
 * Gets anchor Program object for Candy Shop program
 *
 * @param {AnchorWallet | web3.Keypair} wallet Wallet or keypair of connected user
 */
const getProgram = (connection, candyShopProgramId, wallet) => {
    const options = anchor_1.Provider.defaultOptions();
    const provider = new anchor_1.Provider(connection, 
    // check the instance type
    wallet instanceof anchor_1.web3.Keypair ? (0, exports.getNodeWallet)(wallet) : wallet, options);
    const idl = candyShopProgramId.equals(constants_1.CANDY_SHOP_V2_PROGRAM_ID) ? candy_shop_v2_json_1.default : candy_shop_json_1.default;
    // Directly use the JSON file here temporarily
    // @ts-ignore
    return new anchor_1.Program(idl, candyShopProgramId, provider);
};
exports.getProgram = getProgram;
const getAuction = (candyShop, mint, marketProgramId) => {
    return anchor_1.web3.PublicKey.findProgramAddress([Buffer.from(constants_1.AUCTION), candyShop.toBuffer(), mint.toBuffer()], marketProgramId);
};
exports.getAuction = getAuction;
const getBid = (auction, wallet, marketProgramId) => {
    return anchor_1.web3.PublicKey.findProgramAddress([Buffer.from(constants_1.BID), auction.toBuffer(), wallet.toBuffer()], marketProgramId);
};
exports.getBid = getBid;
const getBidWallet = (auction, wallet, marketProgramId) => {
    return anchor_1.web3.PublicKey.findProgramAddress([Buffer.from(constants_1.BID), auction.toBuffer(), wallet.toBuffer(), Buffer.from(constants_1.WALLET)], marketProgramId);
};
exports.getBidWallet = getBidWallet;
const getAuctionHouse = (authority, treasuryMint) => {
    return anchor_1.web3.PublicKey.findProgramAddress([Buffer.from(constants_1.AUCTION_HOUSE), authority.toBuffer(), treasuryMint.toBuffer()], constants_1.AUCTION_HOUSE_PROGRAM_ID);
};
exports.getAuctionHouse = getAuctionHouse;
const getAuctionHouseAuthority = (creator, treasuryMint, marketProgramId) => {
    return anchor_1.web3.PublicKey.findProgramAddress([Buffer.from(constants_1.CANDY_STORE), creator.toBuffer(), treasuryMint.toBuffer(), Buffer.from(constants_1.AUTHORITY)], marketProgramId);
};
exports.getAuctionHouseAuthority = getAuctionHouseAuthority;
const getCandyShop = (creator, treasuryMint, marketProgramId) => {
    return anchor_1.web3.PublicKey.findProgramAddress([Buffer.from(constants_1.CANDY_STORE), creator.toBuffer(), treasuryMint.toBuffer()], marketProgramId);
};
exports.getCandyShop = getCandyShop;
const getCandyShopSync = (creator, treasuryMint, marketProgramId) => {
    return (0, pubkey_1.findProgramAddressSync)([Buffer.from(constants_1.CANDY_STORE), creator.toBuffer(), treasuryMint.toBuffer()], marketProgramId);
};
exports.getCandyShopSync = getCandyShopSync;
const getAuctionHouseProgramAsSigner = () => {
    return anchor_1.web3.PublicKey.findProgramAddress([Buffer.from(constants_1.AUCTION_HOUSE), Buffer.from('signer')], constants_1.AUCTION_HOUSE_PROGRAM_ID);
};
exports.getAuctionHouseProgramAsSigner = getAuctionHouseProgramAsSigner;
const getAuctionHouseTradeState = (auctionHouse, wallet, tokenAccount, treasuryMint, tokenMint, tokenSize, buyPrice) => {
    return anchor_1.web3.PublicKey.findProgramAddress([
        Buffer.from(constants_1.AUCTION_HOUSE),
        wallet.toBuffer(),
        auctionHouse.toBuffer(),
        tokenAccount.toBuffer(),
        treasuryMint.toBuffer(),
        tokenMint.toBuffer(),
        buyPrice.toArrayLike(Buffer, 'le', 8),
        tokenSize.toArrayLike(Buffer, 'le', 8)
    ], constants_1.AUCTION_HOUSE_PROGRAM_ID);
};
exports.getAuctionHouseTradeState = getAuctionHouseTradeState;
const getAuctionHouseFeeAcct = (auctionHouse) => {
    return anchor_1.web3.PublicKey.findProgramAddress([Buffer.from(constants_1.AUCTION_HOUSE), auctionHouse.toBuffer(), Buffer.from(constants_1.FEE_PAYER)], constants_1.AUCTION_HOUSE_PROGRAM_ID);
};
exports.getAuctionHouseFeeAcct = getAuctionHouseFeeAcct;
const getAuctionHouseTreasuryAcct = (auctionHouse) => {
    return anchor_1.web3.PublicKey.findProgramAddress([Buffer.from(constants_1.AUCTION_HOUSE), auctionHouse.toBuffer(), Buffer.from(constants_1.TREASURY)], constants_1.AUCTION_HOUSE_PROGRAM_ID);
};
exports.getAuctionHouseTreasuryAcct = getAuctionHouseTreasuryAcct;
const getAuctionHouseEscrow = (auctionHouse, wallet) => {
    return anchor_1.web3.PublicKey.findProgramAddress([Buffer.from(constants_1.AUCTION_HOUSE), auctionHouse.toBuffer(), wallet.toBuffer()], constants_1.AUCTION_HOUSE_PROGRAM_ID);
};
exports.getAuctionHouseEscrow = getAuctionHouseEscrow;
const getEditionVaultAccount = (candyShop, masterTokenAccount) => {
    return anchor_1.web3.PublicKey.findProgramAddress([candyShop.toBuffer(), Buffer.from(constants_1.EDITION_DROP), masterTokenAccount.toBuffer()], constants_1.EDITION_DROP_PROGRAM_ID);
};
exports.getEditionVaultAccount = getEditionVaultAccount;
const getAtaForMint = (mint, buyer) => {
    return anchor_1.web3.PublicKey.findProgramAddress([buyer.toBuffer(), spl_token_1.TOKEN_PROGRAM_ID.toBuffer(), mint.toBuffer()], spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID);
};
exports.getAtaForMint = getAtaForMint;
const getMetadataAccount = (tokenMint) => {
    return anchor_1.web3.PublicKey.findProgramAddress([Buffer.from('metadata'), constants_1.TOKEN_METADATA_PROGRAM_ID.toBuffer(), tokenMint.toBuffer()], constants_1.TOKEN_METADATA_PROGRAM_ID);
};
exports.getMetadataAccount = getMetadataAccount;
const getMasterEditionAccount = (tokenMint) => {
    return anchor_1.web3.PublicKey.findProgramAddress([Buffer.from('metadata'), constants_1.TOKEN_METADATA_PROGRAM_ID.toBuffer(), tokenMint.toBuffer(), Buffer.from('edition')], constants_1.TOKEN_METADATA_PROGRAM_ID);
};
exports.getMasterEditionAccount = getMasterEditionAccount;
const getEditionMarkAccount = (tokenMint, edition) => {
    const editionNumber = Math.floor(edition / constants_1.EDITION_MARKER_BIT_SIZE);
    return anchor_1.web3.PublicKey.findProgramAddress([
        Buffer.from('metadata'),
        constants_1.TOKEN_METADATA_PROGRAM_ID.toBuffer(),
        tokenMint.toBuffer(),
        Buffer.from('edition'),
        Buffer.from(editionNumber.toString())
    ], constants_1.TOKEN_METADATA_PROGRAM_ID);
};
exports.getEditionMarkAccount = getEditionMarkAccount;
const getSignedTx = (wallet, transaction, extraSigners) => {
    if ('signTransaction' in wallet) {
        if (extraSigners) {
            const extraKeypairs = extraSigners.map((signer) => {
                return {
                    publicKey: signer.publicKey,
                    secretKey: signer.secretKey
                };
            });
            transaction.sign(...extraKeypairs);
        }
        const signedTx = wallet.signTransaction(transaction);
        return signedTx;
    }
    const signers = [
        {
            publicKey: wallet.publicKey,
            secretKey: wallet.secretKey
        }
    ];
    if (extraSigners) {
        const extraKeypairs = extraSigners.map((signer) => {
            return {
                publicKey: signer.publicKey,
                secretKey: signer.secretKey
            };
        });
        signers.push(...extraKeypairs);
    }
    transaction.sign(...signers);
    return transaction;
};
exports.getSignedTx = getSignedTx;
const getCandyShopData = async (candyShop, isEnterprise, program) => {
    const candyShopData = await (isEnterprise
        ? (0, promiseUtils_1.safeAwait)(program.account.enterpriseCandyShopV1.fetch(candyShop))
        : (0, promiseUtils_1.safeAwait)(program.account.candyShopV1.fetch(candyShop)));
    if (candyShopData.error) {
        throw candyShopData.error;
    }
    if (!candyShopData) {
        throw new error_1.CandyShopError(error_1.CandyShopErrorType.CandyShopDoesNotExist);
    }
    return candyShopData.result;
};
exports.getCandyShopData = getCandyShopData;
const getEditionVaultData = async (vaultAccount, program) => {
    const vaultData = await (0, promiseUtils_1.safeAwait)(program.account.vaultAccount.fetch(vaultAccount));
    if (!vaultData) {
        throw new error_1.CandyShopError(error_1.CandyShopErrorType.VaultDoesNotExist);
    }
    if (vaultData.error) {
        throw vaultData.error;
    }
    return vaultData.result;
};
exports.getEditionVaultData = getEditionVaultData;
const getAuctionData = async (auction, program) => {
    const auctionData = await (0, promiseUtils_1.safeAwait)(program.account.auctionV1.fetch(auction));
    if (auctionData.error) {
        throw auctionData.error;
    }
    if (!auctionData) {
        throw new error_1.CandyShopError(error_1.CandyShopErrorType.AuctionDoesNotExist);
    }
    return auctionData.result;
};
exports.getAuctionData = getAuctionData;
const getBidData = async (bid, program) => {
    const bidData = await (0, promiseUtils_1.safeAwait)(program.account.bid.fetch(bid));
    if (bidData.error) {
        throw bidData.error;
    }
    if (!bidData) {
        throw new error_1.CandyShopError(error_1.CandyShopErrorType.BidDoesNotExist);
    }
    return bidData.result;
};
exports.getBidData = getBidData;
const compileAtaCreationIxs = async (payer, addresses, mint, program) => {
    const ix = [];
    for (const addr of addresses) {
        const addrPubKey = new anchor_1.web3.PublicKey(addr);
        const ataAddress = (await (0, exports.getAtaForMint)(mint, addrPubKey))[0];
        const ataAccountRes = await (0, promiseUtils_1.safeAwait)((0, spl_token_1.getAccount)(program.provider.connection, ataAddress));
        const ataAccount = ataAccountRes.result;
        if (!ataAccount || !ataAccount.isInitialized) {
            ix.push((0, spl_token_1.createAssociatedTokenAccountInstruction)(payer, ataAddress, addrPubKey, mint, spl_token_1.TOKEN_PROGRAM_ID, spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID));
        }
    }
    return ix;
};
exports.compileAtaCreationIxs = compileAtaCreationIxs;
const sendTx = async (wallet, transaction, program, extraSigners) => {
    const recentBlockhash = await program.provider.connection.getLatestBlockhash('finalized');
    transaction.recentBlockhash = recentBlockhash.blockhash;
    transaction.feePayer = wallet.publicKey;
    const signedTx = await (0, exports.getSignedTx)(wallet, transaction, extraSigners);
    const txHash = await (0, transactionUtils_1.awaitTransactionSignatureConfirmation)(program.provider.connection, signedTx.serialize());
    return txHash;
};
exports.sendTx = sendTx;
const treasuryMintIsNative = (treasuryMint) => {
    return treasuryMint.equals(constants_1.WRAPPED_SOL_MINT);
};
exports.treasuryMintIsNative = treasuryMintIsNative;
const getNftCreators = async (metadata, connection) => {
    const metadataObj = await connection.getAccountInfo(metadata);
    if (!(metadataObj === null || metadataObj === void 0 ? void 0 : metadataObj.data)) {
        throw new Error(error_1.CandyShopErrorType.InvalidNFTMetadata);
    }
    const metadataDecoded = (0, parseData_1.parseMetadata)(Buffer.from(metadataObj.data));
    if (!metadataDecoded || !metadataDecoded.data || !metadataDecoded.data.creators) {
        throw new Error(error_1.CandyShopErrorType.InvalidNFTMetadata);
    }
    return metadataDecoded.data.creators;
};
exports.getNftCreators = getNftCreators;
const getRemainingAccountsForExecuteSaleIx = async (metadata, connection, treasuryMint, isNative) => {
    const creators = await (0, exports.getNftCreators)(metadata, connection);
    const remainingAccounts = isNative
        ? creators.map((c) => {
            return {
                pubkey: new anchor_1.web3.PublicKey(c.address),
                isWritable: true,
                isSigner: false
            };
        })
        : (await Promise.all(creators.map(async (c) => {
            const key = new anchor_1.web3.PublicKey(c.address);
            const ataAddress = (await (0, exports.getAtaForMint)(treasuryMint, key))[0];
            return [
                {
                    pubkey: key,
                    isWritable: true,
                    isSigner: false
                },
                {
                    pubkey: ataAddress,
                    isWritable: true,
                    isSigner: false
                }
            ];
        }))).flat();
    return remainingAccounts;
};
exports.getRemainingAccountsForExecuteSaleIx = getRemainingAccountsForExecuteSaleIx;
